import React from 'react';

import { Box, Typography } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

interface ScaffolderFieldErrorProps {
  message: React.ReactNode;
}

export const ScaffolderFieldError = ({
  message,
}: ScaffolderFieldErrorProps) => {
  return (
    <Box
      component="span"
      display="inline-flex"
      alignItems="center"
      style={{ gap: 4 }}
    >
      <ErrorOutlineIcon style={{ fontSize: 14, color: '#f44336' }} />
      <Typography variant="caption" color="error">
        {message}
      </Typography>
    </Box>
  );
};
